import React from "react";
import Layout from "../../Layout";
import Form from "./form";
import useApi from "Hooks/Upload/useApi";
import useError from "Hooks/useError";
import { message } from "constants/message";
import useAuth from "Hooks/Upload/useAuth";

export default function Edit(props) {
  const { params } = props.match;
  const userId = parseInt(params.id, 10);

  const { request } = useApi();
  const stateError = useError();
  const { state } = useAuth();
  const messages = message();
  const [user, setUser] = React.useState(null);

  const handleSubmit = ({ name, desc, email, password, userType }) => {
    request({
      method: "PUT",
      url: `media/upload/users/${userId}`,
      data: {
        name: name,
        desc: desc,
        email: email,
        password: password,
        user_type: userType,
      },
    })
      .then((data) => {
        stateError.initialize();
        props.history.push("/upload/config/user?success=edit");
      })
      .catch((error) => {
        stateError.dispatch({
          type: "set",
          payload: {
            isError: true,
            errorMsg: messages.validation.common,
          },
        });
      });
  };

  const fetchData = () => {
    if (!state.user.email) {
      return;
    }

    // アカウント情報取得
    request({
      method: "GET",
      url: `media/upload/users/${userId}`,
    }).then((result) => {
      setUser(result.data.data);
    });
    
  };

  React.useEffect(() => {
    // タイトル変更
    document.title = "Buzz Finder Upload - ユーザ編集";
  }, []);

  React.useEffect(() => {    
    fetchData();
  }, [state.user.email]);

  return (
    <Layout
      content={
        <Form
          submit={handleSubmit}
          user={user}
          isEdit={true}
        />
      }
    />
  );
}
